<script setup lang="ts">
import { useRouter } from 'vue-router'

defineProps({
    value: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
})

const emit = defineEmits(['close', 'cancel'])

const router = useRouter()
function onProfile() {
    router.push('/adressen/profil')
    emit('close')
}
</script>

<template>
    <v-dialog :model-value="value" persistent :max-width="600" @click:outside="$emit('cancel')">
        <v-card>
            <slot name="title">
                <v-card-title class="headline">{{ $t('profile_missing') }}</v-card-title>
            </slot>
            <slot>
                <v-card-text>{{ $t('profile_missing_for_gesuch') }}</v-card-text>
            </slot>
            <slot name="actions">
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary darken-1"
                        text
                        :loading="loading"
                        @click="$emit('cancel')"
                    >
                        {{ $t('cancel') }}
                    </v-btn>
                    <v-btn color="action white--text" variant="flat" :disabled="loading" @click="onProfile">
                        {{ $t('edit_profile') }}
                    </v-btn>
                </v-card-actions>
            </slot>
        </v-card>
    </v-dialog>
</template>

<style scoped>
.v-card__text,
.v-card__title {
    word-break: normal !important;
}
</style>
